module.exports = __webpack_public_path__ + "img/4-penguin-helper_v8e.634414c2.png";